<nz-modal nzClassName="mobile-app-qr-code-modal" [nzVisible]="isVisible" [nzContent]="modalContent" [nzFooter]="null"
  nzWidth="800px" (nzOnCancel)="close()" [nzCentered]="true">
</nz-modal>

<ng-template #modalContent>
  <div class="mobile-app-content">
    <div class="qr-overlay" (click)="onQrClick()"></div>
    <img src="https://cdn.qne.cloud/qca/assets/img/ui/qca-mobile-download-popup.webp" alt="QR Code" style="width: 101%;" />

    <div class="mobile-app-footer">
      <div class="footer-content">
        <span class="available-text">Available on Android</span>
        <a href="https://play.google.com/store/apps/details?id=com.qne.app" target="_blank" class="google-play-button">
          <img src="../../../../../assets/img/GetItOnGooglePlay_Badge_Web_color_English.png"
            alt="Get it on Google Play" />
        </a>
      </div>
    </div>
  </div>
</ng-template>